import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import BrandRegistrationDialog from "./BrandRegistrationDialog";
import InfluencerRegistrationDialog from "./InfluencerRegistrationDialog";

interface JoinNowButtonProps {
  className?: string;
  variant?: "default" | "text";
}

const JoinNowButton = ({ className, variant = "default" }: JoinNowButtonProps) => {
  const [brandDialogOpen, setBrandDialogOpen] = useState(false);
  const [influencerDialogOpen, setInfluencerDialogOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  
  // Determine if we're on the brands page
  const isBrandsPage = location.pathname === '/brands';

  useEffect(() => {
    if (brandDialogOpen) {
      console.log("Brand Registration Dialog opened");
    }
    if (influencerDialogOpen) {
      console.log("Influencer Registration Dialog opened");
    }
  }, [brandDialogOpen, influencerDialogOpen]);

  return (
    <>
      {variant === "text" ? (
        <button
          className={cn("text-white font-bold hover:text-white/80 transition-colors", className)}
          aria-label="Join Cloutfit.ai / Outfit Alliance"
          onClick={() => {
            console.log("JoinNowButton clicked");
            if (isBrandsPage) {
              navigate('/brandsignup');
            } else {
              navigate('/creatorsignup');
            }
          }}
        >
          Join now
        </button>
      ) : (
        <Button
          size="lg"
          variant="hero"
          className={cn("px-6", className)}
          aria-label="Join Cloutfit.ai / Outfit Alliance"
          onClick={() => {
            console.log("JoinNowButton clicked");
            if (isBrandsPage) {
              navigate('/brandsignup');
            } else {
              navigate('/creatorsignup');
            }
          }}
        >
          Join now
        </Button>
      )}
      
      <BrandRegistrationDialog 
        open={brandDialogOpen} 
        onOpenChange={setBrandDialogOpen}
      />
      
      <InfluencerRegistrationDialog 
        open={influencerDialogOpen} 
        onOpenChange={setInfluencerDialogOpen}
      />
    </>
  );
};

export default JoinNowButton;
